export const projects = [
  {
    title: 'CRM / NMS Platform',
    name: 'Management System',
    image: require('../assets/laravel.png'),
    content:
      'A comprehensive CRM and Network Management System built with PHP Laravel, MySQL, and MongoDB. I actively develop new features and maintain the platform.',
    link: null,
  },
  {
    title: 'Web Application',
    name: 'Customer Portal',
    image: null,
    content:
      'Company website and online customer portal built with Next.js. Customers can manage their accounts, view invoices, and perform self-service operations.',
    link: null,
  },
  {
    title: 'Mobile App — React Native CLI',
    name: 'Customer Mobile App',
    image: null,
    content:
      'Cross-platform iOS and Android app built with React Native CLI. Customers can view and pay invoices, open support tickets, check internet line stats, set up modems using custom installation scripts, and upload documents.',
    link: null,
  },
  {
    title: 'Mobile App — Expo',
    name: 'Field Team App',
    image: require('../assets/expo.png'),
    content:
      'Internal mobile application built with Expo for the field team. Helps technicians manage their tasks, track operations, and report from the field.',
    link: null,
  },
];
